import { defineStore } from 'pinia'
import { ref } from 'vue'
import { appendChannelId, readChannelId } from '@/utils/channel'

/** 仅保留当前浏览链路的渠道，避免下次冷启动误用历史渠道。 */
export const useChannelStore = defineStore('channel', () => {
  const channelId = ref('')
  const initialized = ref(false)
  const pendingTab = ref<{ path: string, channelId: string } | null>(null)
  return { channelId, initialized, pendingTab }
})

export function browserChannelId(): string | undefined {
  // #ifdef H5
  if (typeof window !== 'undefined')
    return readChannelId(window.location.href)
  // #endif
  return undefined
}

export function getCurrentChannelId(): string {
  const store = useChannelStore()
  return store.initialized ? store.channelId : browserChannelId() || ''
}

export function appendCurrentChannelId(url: string): string {
  return appendChannelId(url, getCurrentChannelId())
}
